import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const TOKEN_KEY = "tdf_dtm_token";

const DtmAuthContext = createContext(null);

export function useDtmAuth() { return useContext(DtmAuthContext); }

export function DtmAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [coach, setCoach] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  const apiClient = useCallback(() => {
    return axios.create({
      baseURL: API,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  }, [token]);

  useEffect(() => {
    if (!token) { setCoach(null); setLoading(false); return; }
    apiClient().get("/interview-coaching/coach/me")
      .then((r) => {
        setCoach(r.data.coach);
        setMustChangePassword(Boolean(r.data.coach?.must_change_password));
      })
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setToken(""); setCoach(null); })
      .finally(() => setLoading(false));
  }, [token, apiClient]);

  const login = useCallback(async (email, password) => {
    const res = await axios.post(`${API}/interview-coaching/coach/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    setMustChangePassword(Boolean(res.data.must_change_password));
    setToken(res.data.token);
    return res.data;
  }, []);

  const applySession = useCallback((sessionToken) => {
    localStorage.setItem(TOKEN_KEY, sessionToken);
    setMustChangePassword(false);
    setToken(sessionToken);
  }, []);

  const changePassword = useCallback(async (currentPassword, newPassword) => {
    await apiClient().post("/interview-coaching/coach/change-password", {
      current_password: currentPassword,
      new_password: newPassword,
    });
    setMustChangePassword(false);
  }, [apiClient]);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
    setCoach(null);
    setMustChangePassword(false);
  }, []);

  return (
    <DtmAuthContext.Provider value={{ token, coach, loading, mustChangePassword, login, logout, changePassword, applySession, apiClient }}>
      {children}
    </DtmAuthContext.Provider>
  );
}
